import { forwardRef, type Ref, type SVGProps } from "react";
const IconHomeTypeOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="m28.34 7.06-14-5a1 1 0 0 0-.92.12A1 1 0 0 0 13 3v13.35l-2.33-2.09a1 1 0 0 0-1.34 0l-5.82 5.22A1.55 1.55 0 0 0 3 20.62v8.11A1.27 1.27 0 0 0 4.27 30H28a1 1 0 0 0 1-1V8a1 1 0 0 0-.66-.94M11 28H9v-3h2zm4 0h-2v-3.5a1.5 1.5 0 0 0-1.5-1.5h-3A1.5 1.5 0 0 0 7 24.5V28H5v-7.17l5-4.49 5 4.49zm12 0H17v-7.38a1.55 1.55 0 0 0-.51-1.14L15 18.12V4.42l12 4.29z"
    />
    <path
      fill="currentColor"
      d="M24 13v10a1 1 0 0 1-2 0V13a1 1 0 0 1 2 0m-4-2v12a1 1 0 0 1-2 0V11a1 1 0 0 1 2 0"
    />
  </svg>
);
const ForwardRef = forwardRef(IconHomeTypeOutlineSVG);
ForwardRef.displayName = "IconHomeTypeOutline";
export { ForwardRef as IconHomeTypeOutline };
